import Video from "./Video";
import VideoObserver from '../components/VideoObserver';

export default class HtmlVideoPlayer extends Video {
	constructor(element, options)
	{
		super(element, options)

		this.video 					= element.querySelector('video');
		this.videoMob 				= element.querySelector('.video__mobile');
		this.startButton 			= element.querySelector('.video__cover');

		if( this.videoMob && window.matchMedia("(max-width:1023px)").matches ){
			this.video = this.videoMob;
		}

		for (let option in this.options)
		{
			let bool = this.options[option];
			switch(option)
			{
				case 'autoplay':
					this.video.autoplay = bool;
					if (bool)
					{
						// Pausing video until it enters the viewport
						this.pause();
						this.videoDesktopObserver = new VideoObserver(this.video)
						// console.log('video being observed:' )
						// console.log(this.video)
					} else {
						this.pause();
					}
					break;
				case 'loop':
					this.video.loop = bool;
					break;
				case 'muted':
					this.video.muted = this.options[option]
					bool ? this.mute() : this.setVolume(1)
					break;
				case 'controls':
					bool ? '' : this.destroyControls()
				case 'progress':
					if (bool)
					{
						if(this.options.progress !== false && this.progressBar)
						{
							this.video.addEventListener('timeupdate', () => this.updateTimeElapsed(this.video.duration, this.video.currentTime));
							this.getSeek(this.video.duration, this.video.currentTime)
						}
					} else
					{
						this.hideProgress()
					}
			}
		}

		// CATERING TO COVER IMAGE STYLES
		this.options.cover && this.startButton.addEventListener('click', () =>
		{
			this.uncover()
		})

		// FULLSCREEN
		this.fullscreenButton && this.fullscreenButton.addEventListener('click', () =>
		{
			this.fullscreen()
		})

		// CREATING HOVER TO PLAY
		if(this.options.hoverToPlay)
		{

			// ON MOBILE WE WANT HOVER TO PLAY TO SWITCH TO SCREEN INTERSECTION
			if( window.app.isHover == false ){
				console.log('this is a device with no hover')
				let intersectionOptions = {
					root: null, // Use the viewport as the root
					rootMargin: '0px', // No additional margin
					threshold: 1, // Trigger when 0 of the video is visible
				}
				this.videoDesktopObserver = new VideoObserver(this.video,intersectionOptions,this.element)
			} else {
				// console.log(`this is a device with hover`)
				this.element.addEventListener('mouseenter', () =>
				{
					this.hoverToPlay()
				})
				this.element.addEventListener('mouseleave', () =>
				{
					this.video.pause()
				})
			}

		} 

	}
	uncover(){
		this.element.classList.add('video--uncovered')
		this.play()
	}
	play(){
		super.play()
		this.video.play();
	}
	mute(){
		super.mute();
		this.video.muted = true;
	}
	restart()
	{
		super.restart();
		this.video.currentTime = this.video.duration * 0.005;
	}
	pause(){
		super.pause()
		this.video.pause()
	}
	setVolume(amount){
		super.setVolume(amount)
		this.video.muted = false;
		this.video.volume = 1;
	}
	setTime(percentage)
	{
		super.setTime(percentage);
		let seconds = Math.max((percentage / 100) * this.video.duration, 0)
		this.video.currentTime = seconds;
	}
	hoverToPlay(){
		this.element.classList.add('video--uncovered')
		super.play()
		this.video.play()
	}
}